import api from "../../api/api";

const submitComplaint = (data) =>{
    return new Promise((resolve, reject)=>{
        api.post("/guest/complaint/submit",data,  
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }
        ).then( (res)=>{
            resolve(res.data)
        }).catch( (error) => {
            reject(error)
        })
    });
}


const reopenComplaint = (data) =>{
    return new Promise((resolve, reject)=>{
        api.post("/guest/complaint/reopen",data,  
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }
        ).then( (res)=>{
            resolve(res.data)
        }).catch( (error) => {
            reject(error)
        })
    });
}

const getComplaintList = (phone) =>{
    return new Promise((resolve, reject)=>{
        api.get("/guest/complaint/list/"+phone).then( (res)=>{
            resolve(res.data)
        }).catch( (error) => {
            reject(error)
        })
    });
}


const getComplaintById = (gid) =>{
    return new Promise((resolve, reject)=>{
        api.get("/guest/complaint/id/"+gid).then( (res)=>{
            resolve(res.data)
        }).catch( (error) => {
            reject(error)
        })
    });
}


const portalServices = {
    getComplaintList,
    getComplaintById,
    submitComplaint,
    reopenComplaint

}
export default portalServices;